export default __webpack_public_path__ + "static/media/graphics.9c514c79.png";